__webpack_require__.p = "/vythaor-portfolio/";